import * as React from 'react';

export interface MarkdownToolbarIconProps {
  className?: string;
}

interface ToolbarIconProps extends MarkdownToolbarIconProps {
  children: React.ReactNode;
}

const ToolbarIcon = ({ children, className }: ToolbarIconProps) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    focusable="false"
    height="18"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.75"
    viewBox="0 0 20 20"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    {children}
  </svg>
);

export const ChevronDownIcon = (props: MarkdownToolbarIconProps) => (
  <ToolbarIcon {...props}>
    <path d="m6 8 4 4 4-4" />
  </ToolbarIcon>
);

export const BoldIcon = (props: MarkdownToolbarIconProps) => (
  <ToolbarIcon {...props}>
    <path d="M6.25 3.75h4.5a3 3 0 0 1 0 6h-4.5z" />
    <path d="M6.25 9.75h5.25a3.25 3.25 0 0 1 0 6.5H6.25z" />
  </ToolbarIcon>
);

export const ItalicIcon = (props: MarkdownToolbarIconProps) => (
  <ToolbarIcon {...props}>
    <path d="M10 4h5" />
    <path d="M5 16h5" />
    <path d="m12.5 4-5 12" />
  </ToolbarIcon>
);

export const UnorderedListIcon = (props: MarkdownToolbarIconProps) => (
  <ToolbarIcon {...props}>
    <circle cx="4" cy="5" fill="currentColor" r="0.8" stroke="none" />
    <circle cx="4" cy="10" fill="currentColor" r="0.8" stroke="none" />
    <circle cx="4" cy="15" fill="currentColor" r="0.8" stroke="none" />
    <path d="M7 5h9M7 10h9M7 15h9" />
  </ToolbarIcon>
);

export const OrderedListIcon = (props: MarkdownToolbarIconProps) => (
  <ToolbarIcon {...props}>
    <path d="M3 4h1v3M3 7h2" />
    <path d="M3 10.25c.3-.45.7-.75 1.2-.75.65 0 1.05.4 1.05.9 0 .4-.2.7-.65 1.1L3 13h2.25" />
    <path d="M8 5h8M8 10h8M8 15h8" />
  </ToolbarIcon>
);

export const InlineCodeIcon = (props: MarkdownToolbarIconProps) => (
  <ToolbarIcon {...props}>
    <path d="m7 6-4 4 4 4M13 6l4 4-4 4M11.5 4.5l-3 11" />
  </ToolbarIcon>
);

export const LinkIcon = (props: MarkdownToolbarIconProps) => (
  <ToolbarIcon {...props}>
    <path d="m8 12 4-4" />
    <path d="M6.25 14.75H5a3.75 3.75 0 0 1 0-7.5h3" />
    <path d="M13.75 5.25H15a3.75 3.75 0 0 1 0 7.5h-3" />
  </ToolbarIcon>
);

export const TableIcon = (props: MarkdownToolbarIconProps) => (
  <ToolbarIcon {...props}>
    <rect height="12" rx="1" width="14" x="3" y="4" />
    <path d="M3 8h14M3 12h14M8 4v12M13 4v12" />
  </ToolbarIcon>
);

export const QuoteIcon = (props: MarkdownToolbarIconProps) => (
  <ToolbarIcon {...props}>
    <path d="M8.25 6.25h-3a2 2 0 0 0-2 2v1.5h5v4h-5v-4c0-2.75 1.25-4.75 3.75-6" />
    <path d="M16.75 6.25h-3a2 2 0 0 0-2 2v1.5h5v4h-5v-4c0-2.75 1.25-4.75 3.75-6" />
  </ToolbarIcon>
);

export const UndoIcon = (props: MarkdownToolbarIconProps) => (
  <ToolbarIcon {...props}>
    <path d="m7 6-4 4 4 4" />
    <path d="M4 10h7.25a5 5 0 0 1 5 5" />
  </ToolbarIcon>
);

export const RedoIcon = (props: MarkdownToolbarIconProps) => (
  <ToolbarIcon {...props}>
    <path d="m13 6 4 4-4 4" />
    <path d="M16 10H8.75a5 5 0 0 0-5 5" />
  </ToolbarIcon>
);

export const StatusCheckIcon = (props: MarkdownToolbarIconProps) => (
  <ToolbarIcon {...props}>
    <circle cx="10" cy="10" fill="currentColor" r="8" stroke="none" />
    <path d="m6.5 10 2.25 2.25 4.75-4.75" stroke="white" strokeWidth="1.8" />
  </ToolbarIcon>
);
